
<div class="container-fluid  ">
  <div class="row justify-content-center">
      <div class="col-11 col-sm-10 col-md-10 col-lg-10 col-xl-10 text-center ">


         <!-- formulaire enrollement -->
         <div class="card"  style="padding: 10px;">
          <div class="d-flex justify-content-center">
            <h5 id="heading" class="text-dark" style="font-size: 12px;">Ajout action</h5>
            <button type="button"  class="btn btn-link position-absolute" style="top: 10px; right: 10px;" aria-label="Close" (click)="closeModal()" >
              <i class="fas fa-times text-dark" style="font-size: 1.5rem; "></i>
            </button>
          </div>
          <!-- <p>Fill all form field to go to next step</p> -->
          <form  #form="ngForm" (ngSubmit)="onSubmit(form)" novalidate id="msform" style="min-height: 300px;">
              <!-- progressbar -->
              <ul id="progressbar">
                  <li class="active" id="step1"><strong>Informations</strong></li>
                  <!-- <li id="step2"><strong>Informations amende</strong></li> -->
                  <!-- <li id="step4"><strong>Decisions</strong></li> -->
                  <!-- <li id="step5"><strong>N° role</strong></li>
                  <li id="step3"><strong>Calendrier</strong></li> -->

              </ul>
              <!-- <div class="progress">
                  <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuemin="0" aria-valuemax="100"></div>
              </div>  -->
              <br><br> <!-- fieldsets -->
              <fieldset class="{{step}}" >
                <div class="form-card shadow m-auto" style="padding: 20px;">
                  <div class="d-flex flex-column align-items-center">
                    <div class="col-md-6 m-auto text-center">
                      <label class="fieldlabels">Titre: *</label>
                      <input class="form-control" type="text" name="titre" [(ngModel)]="titre" />
                    </div>
                    
                    <div class="col-md-6 m-auto text-center" *ngIf="show_profil_auth != false" >
                      <label class="fieldlabels">profils autorisés: </label>
                      <textarea style="height: 150px;" class="form-control"  name="profil_authoriser" ngModel></textarea>
                    </div>
                  </div>
                  <div class="col-md-6 m-auto text-center d-flex justify-content-between flex-wrap ">
                    <div class="d-flex justify-content-start text-nowrap ">
                      <label class="fieldlabels ml-1">crée document: </label>&nbsp;
                      <input type="checkbox" name="create_document" id="create_document" [(ngModel)]="createDocument">
                    </div>
                  
                    <div class="d-flex justify-content-start text-nowrap">
                      <label class="fieldlabels ml-1">crée tag: </label>&nbsp;
                      <input type="checkbox" name="create_tag" id="create_tag" [(ngModel)]="createTag">
                    </div>
                  </div>
                  
                </div>
                
              <!-- <input type="button" name="next" class="next action-button" value="Suivant" /> -->
              <input type="submit" name="next"  class="next action-button bg-dark" value="Enregistrer"
                     style="margin-left: 7%;min-width: 200px;"  />
              </fieldset>

              


          </form>


      </div>


      </div>
  </div>
</div>
